import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, can } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import POS from "@/pages/POS";
import Products from "@/pages/Products";
import Categories from "@/pages/Categories";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import InvoiceForm from "@/pages/InvoiceForm";
import Payments from "@/pages/Payments";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import Customers from "@/pages/Customers";
import CustomerDetails from "@/pages/CustomerDetails";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import AIAssistant from "@/pages/AIAssistant";
import Store from "@/pages/Store";
import ProductDetails from "@/pages/ProductDetails";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen w-full flex items-center justify-center bg-white"><div className="animate-pulse text-zinc-400 font-heading text-lg" data-testid="auth-loading">Loading Demodog World Inc.…</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  const G = (perm, el) => (can(user.role, perm) ? el : <Navigate to="/pos" replace />);
  return (
    <AppShell>
      <Routes>
        <Route path="/pos" element={<POS />} />
        <Route path="/products" element={G("products", <Products />)} />
        <Route path="/categories" element={G("products", <Categories />)} />
        <Route path="/products/:id" element={G("products", <ProductDetails />)} />
        <Route path="/orders" element={G("orders", <Orders />)} />
        <Route path="/invoices" element={G("invoices", <Invoices />)} />
        <Route path="/invoices/new" element={G("invoices", <InvoiceForm mode="create" />)} />
        <Route path="/invoices/:id/edit" element={G("invoices", <InvoiceForm mode="edit" />)} />
        <Route path="/payments" element={G("payments", <Payments />)} />
        <Route path="/dashboard" element={G("dashboard", <Dashboard />)} />
        <Route path="/customers" element={G("customers", <Customers />)} />
        <Route path="/customers/:id" element={G("customers", <CustomerDetails />)} />
        <Route path="/employees" element={G("employees", <Employees />)} />
        <Route path="/reports" element={G("reports", <Reports />)} />
        <Route path="/ai" element={<AIAssistant />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/pos" replace />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/store/*" element={<Store />} />
              <Route path="/*" element={<Protected><Shell /></Protected>} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
